import { IPaths } from "~/types/routing";

export const paths: IPaths = {
  home: "/",
  customization: "/customization",
};
